import { render, staticRenderFns } from "./notesmanager.vue?vue&type=template&id=a8077aec&lang=pug"
import script from "./notesmanager.vue?vue&type=script&lang=js"
export * from "./notesmanager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports